export default __webpack_public_path__ + "static/explore-learning-715c1748b5cb29a2fbd448d878bf9389.jpg";